import React from 'react';
import {fieldValueText} from '../../../_helpers/form';
import {getSelectedValidationResolution, getSelectedValidationResolutionSetter} from './functions';

type CustomerValidationProps = {
    formState: any;
    form: any;
    searchModalState: any;
    setSearchModalState: any;
    workflowFieldMap: any;
};
export const CustomerValidation: React.FunctionComponent<CustomerValidationProps> = ({
                                                                                         formState,
                                                                                         form,
                                                                                         searchModalState,
                                                                                         setSearchModalState,
                                                                                         workflowFieldMap
                                                                                     }): JSX.Element => {
    const choice = getSelectedValidationResolution(searchModalState);
    const setChoice = getSelectedValidationResolutionSetter('customer', setSearchModalState);
    const enteredCustomerNumber = fieldValueText(formState as any, form as any, workflowFieldMap.soldToCustomerNumberFieldId);

    return (
        <div>
            The Customer# ({searchModalState?.selectedInvoice?.customerNumber}) on the Invoice does not match the
            Customer# ({enteredCustomerNumber}) you have entered on the workflow. Select how you would like to proceed:

            <div className="m-2">
                <div className="form-check mb-2">
                    <input type="radio"
                           className="form-check-input"
                           id="customer-validation-update"
                           checked={choice === 'update'}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) => e.target.checked && setChoice('update')}
                    />
                    <label className="form-check-label"
                           htmlFor="customer-validation-update">
                        Update the Workflow with the Customer# ({searchModalState?.selectedInvoice?.customerNumber}) on the Invoice
                    </label>
                </div>
                <div className="form-check">
                    <input type="radio"
                           className="form-check-input"
                           id="customer-validation-keep"
                           checked={choice === 'keep'}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) => e.target.checked && setChoice('keep')}
                    />
                    <label className="form-check-label"
                           htmlFor="customer-validation-keep">
                        Leave the Customer# ({enteredCustomerNumber}) on the Workflow.
                    </label>
                </div>
            </div>
        </div>
    );
}